import api from '@/api';

const BASE = '/admin/print3d';

// ===== Materiales =====
export async function getMaterials(offset = 0, limit = 20, filter = {}) {
    try {
        let q = `?offset=${offset}&limit=${limit}`;
        if (filter.name) q += `&name=${encodeURIComponent(filter.name)}`;
        if (filter.id) q += `&id=${encodeURIComponent(filter.id)}`;
        if (filter.includeInactive) q += `&includeInactive=true`;
        const res = await api.get(`${BASE}/materials${q}`);
        return {
            items: res.data.items,
            totalPages: Math.ceil(res.data.totalItems / limit) || 1,
        };
    } catch (err) {
        console.error('getMaterials error:', err);
        return { items: [], totalPages: 1 };
    }
}

export async function getMaterialById(id) {
    try {
        const res = await api.get(`${BASE}/materials/${id}`);
        return { data: res.data };
    } catch (err) {
        console.error('getMaterialById error:', err);
        return { data: null };
    }
}

export async function saveMaterial(data) {
    try {
        const res = await api.post(`${BASE}/materials`, data);
        return { response: res.data, error: null };
    } catch (err) {
        console.error('saveMaterial error:', err);
        return { response: null, error: err.response?.data?.error || err.message };
    }
}

export async function editMaterial(id, data) {
    try {
        const res = await api.patch(`${BASE}/materials/${id}`, data);
        return { response: res.data, error: null };
    } catch (err) {
        console.error('editMaterial error:', err);
        return { response: null, error: err.response?.data?.error || err.message };
    }
}

export async function deleteMaterial(id) {
    try {
        const res = await api.delete(`${BASE}/materials/${id}`);
        return { response: res.data, error: null };
    } catch (err) {
        console.error('deleteMaterial error:', err);
        return {
            response: null,
            error: err.response?.data?.error || err.message,
            details: err.response?.data?.details,
        };
    }
}

// ===== Categorías de impresión ("Tipo de impresión") =====
export async function getCategories(includeInactive = false) {
    try {
        const q = includeInactive ? '?includeInactive=true' : '';
        const res = await api.get(`${BASE}/categories${q}`);
        return { categories: res.data.categories || [], error: null };
    } catch (err) {
        console.error('getCategories error:', err);
        return { categories: [], error: err.response?.data?.error || err.message };
    }
}

export async function saveCategory(data) {
    try {
        const res = await api.post(`${BASE}/categories`, data);
        return { response: res.data, error: null };
    } catch (err) {
        console.error('saveCategory error:', err);
        return { response: null, error: err.response?.data?.error || err.message };
    }
}

export async function editCategory(id, data) {
    try {
        const res = await api.patch(`${BASE}/categories/${id}`, data);
        return { response: res.data, error: null };
    } catch (err) {
        console.error('editCategory error:', err);
        return { response: null, error: err.response?.data?.error || err.message };
    }
}

export async function deleteCategory(id) {
    try {
        const res = await api.delete(`${BASE}/categories/${id}`);
        return { response: res.data, error: null };
    } catch (err) {
        console.error('deleteCategory error:', err);
        return { response: null, error: err.response?.data?.error || err.message };
    }
}

// ===== Categorías del catálogo (familias comerciales) =====
// Distintas de las de impresión (`getCategories`): agrupan los productos que
// el visitante navega en /print3d/catalogo.
export async function getProductCategories(includeInactive = false) {
    try {
        const q = includeInactive ? '?includeInactive=true' : '';
        const res = await api.get(`${BASE}/product-categories${q}`);
        return { categories: res.data.categories || [], error: null };
    } catch (err) {
        console.error('getProductCategories error:', err);
        return { categories: [], error: err.response?.data?.error || err.message };
    }
}

export async function saveProductCategory(data) {
    try {
        const res = await api.post(`${BASE}/product-categories`, data);
        return { response: res.data, error: null };
    } catch (err) {
        console.error('saveProductCategory error:', err);
        return { response: null, error: err.response?.data?.error || err.message };
    }
}

export async function editProductCategory(id, data) {
    try {
        const res = await api.patch(`${BASE}/product-categories/${id}`, data);
        return { response: res.data, error: null };
    } catch (err) {
        console.error('editProductCategory error:', err);
        return { response: null, error: err.response?.data?.error || err.message };
    }
}

export async function deleteProductCategory(id) {
    try {
        const res = await api.delete(`${BASE}/product-categories/${id}`);
        return { response: res.data, error: null };
    } catch (err) {
        console.error('deleteProductCategory error:', err);
        return { response: null, error: err.response?.data?.error || err.message };
    }
}

// ===== Productos =====
export async function getProducts(offset = 0, limit = 20, filter = {}) {
    try {
        let q = `?offset=${offset}&limit=${limit}`;
        if (filter.name) q += `&name=${encodeURIComponent(filter.name)}`;
        if (filter.materialId) q += `&materialId=${encodeURIComponent(filter.materialId)}`;
        if (filter.categoryId) q += `&categoryId=${encodeURIComponent(filter.categoryId)}`;
        if (filter.isFeatured) q += `&isFeatured=true`;
        if (filter.includeInactive) q += `&includeInactive=true`;
        const res = await api.get(`${BASE}/products${q}`);
        return {
            items: res.data.items,
            totalPages: Math.ceil(res.data.totalItems / limit) || 1,
        };
    } catch (err) {
        console.error('getProducts error:', err);
        return { items: [], totalPages: 1 };
    }
}

export async function getProductById(id) {
    try {
        const res = await api.get(`${BASE}/products/${id}`);
        return { data: res.data };
    } catch (err) {
        console.error('getProductById error:', err);
        return { data: null };
    }
}

export async function saveProduct(data) {
    try {
        const res = await api.post(`${BASE}/products`, data);
        return { response: res.data, error: null };
    } catch (err) {
        console.error('saveProduct error:', err);
        return { response: null, error: err.response?.data?.error || err.message };
    }
}

export async function editProduct(id, data) {
    try {
        const res = await api.patch(`${BASE}/products/${id}`, data);
        return { response: res.data, error: null };
    } catch (err) {
        console.error('editProduct error:', err);
        return { response: null, error: err.response?.data?.error || err.message };
    }
}

export async function deleteProduct(id) {
    try {
        const res = await api.delete(`${BASE}/products/${id}`);
        return { response: res.data, error: null };
    } catch (err) {
        console.error('deleteProduct error:', err);
        return { response: null, error: err.response?.data?.error || err.message };
    }
}

// Sube las imágenes del catálogo al backend en una sola petición. Devuelve
// `{ images, error }` con las rutas relativas tipo
// `/uploads/print3d/products/<uuid>.png` EN EL MISMO ORDEN en que se enviaron.
// El frontend público las resuelve a URL absoluta vía `print3dService.resolveImageUrl`.
export async function uploadProductImages(files) {
    try {
        const fd = new FormData();
        files.forEach((file) => fd.append('images', file));
        const res = await api.post(`${BASE}/products/upload-image`, fd, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return { images: (res.data.images || []).map((i) => i.imageUrl), error: null };
    } catch (err) {
        console.error('uploadProductImages error:', err);
        return { images: [], error: err.response?.data?.error || err.message };
    }
}

// ===== Solicitudes / Órdenes =====
export async function getOrders(offset = 0, limit = 20, filter = {}) {
    try {
        let q = `?offset=${offset}&limit=${limit}`;
        if (filter.requestType) q += `&requestType=${encodeURIComponent(filter.requestType)}`;
        if (filter.status) q += `&status=${encodeURIComponent(filter.status)}`;
        if (filter.contactEmail) q += `&contactEmail=${encodeURIComponent(filter.contactEmail)}`;
        if (filter.dateFrom) q += `&dateFrom=${encodeURIComponent(filter.dateFrom)}`;
        if (filter.dateTo) q += `&dateTo=${encodeURIComponent(filter.dateTo)}`;
        const res = await api.get(`${BASE}/quote-requests${q}`);
        return {
            items: res.data.items,
            totalPages: Math.ceil(res.data.totalItems / limit) || 1,
            totalItems: res.data.totalItems,
        };
    } catch (err) {
        console.error('getOrders error:', err);
        return { items: [], totalPages: 1, totalItems: 0 };
    }
}

export async function getOrderById(id) {
    try {
        const res = await api.get(`${BASE}/quote-requests/${id}`);
        return { data: res.data };
    } catch (err) {
        console.error('getOrderById error:', err);
        return { data: null };
    }
}

export async function updateOrder(id, data) {
    try {
        const res = await api.patch(`${BASE}/quote-requests/${id}`, data);
        return { response: res.data, error: null };
    } catch (err) {
        console.error('updateOrder error:', err);
        return { response: null, error: err.response?.data?.error || err.message };
    }
}

export async function deleteOrder(id) {
    try {
        await api.delete(`${BASE}/quote-requests/${id}`);
        return { error: null };
    } catch (err) {
        console.error('deleteOrder error:', err);
        return { error: err.response?.data?.error || err.message };
    }
}

// Descarga del adjunto. Devuelve un Blob — el caller crea el object URL y dispara el download.
// Previsualización del pedido personalizado: el endpoint exige sesión, así
// que se descarga como blob y se devuelve un object URL para el <img>.
export async function fetchPreview(id) {
    try {
        const res = await api.get(`${BASE}/quote-requests/${id}/preview`, {
            responseType: 'blob',
        });
        return { url: window.URL.createObjectURL(new Blob([res.data])), error: null };
    } catch (err) {
        console.error('fetchPreview error:', err);
        return { url: null, error: err.response?.data?.error || err.message };
    }
}

/**
 * Nombre de archivo que declara la cabecera `Content-Disposition`.
 *
 * Contempla las dos formas: `filename*=UTF-8''…` (RFC 5987, con prioridad) y
 * `filename="…"`. El servidor codifica el valor con `encodeURIComponent`, así
 * que se decodifica antes de devolverlo.
 */
function filenameFromDisposition(disposition) {
    if (!disposition) return null;
    const extended = disposition.match(/filename\*=UTF-8''([^;]+)/i);
    const plain = disposition.match(/filename="?([^";]+)"?/i);
    const raw = (extended?.[1] || plain?.[1] || '').trim();
    if (!raw) return null;
    try {
        return decodeURIComponent(raw);
    } catch {
        return raw;
    }
}

// Extensión de respaldo por tipo de archivo. Un nombre SIN extensión hace que
// el navegador la deduzca del tipo del blob y, si tampoco lo hay, guarde un
// `.txt` — que fue justo lo que pasó con los primeros troqueles.
const ARTIFACT_FALLBACK = {
    dieStl: { ext: 'stl', mime: 'model/stl', label: 'troquel' },
    imageSvg: { ext: 'svg', mime: 'image/svg+xml', label: 'imagen' },
};

/**
 * Descarga un archivo de producción del pedido personalizado.
 *
 * `kind` es `dieStl` (troquel en STL) o `imageSvg` (imagen vectorizada). El
 * nombre lo decide el servidor, que conoce el tamaño y las piezas; aquí se lee
 * de la cabecera. Como la descarga pasa por un blob, el navegador NO aplica el
 * `Content-Disposition` por su cuenta: el nombre y el tipo hay que ponerlos a
 * mano en el enlace y en el blob.
 *
 * El SVG nunca se inserta en el panel: se guarda como archivo, porque un SVG es
 * contenido activo y el panel es un origen con sesión.
 */
export async function downloadArtifact(id, kind, filename) {
    try {
        const res = await api.get(`${BASE}/quote-requests/${id}/artifact/${kind}`, {
            responseType: 'blob',
        });
        const fallback = ARTIFACT_FALLBACK[kind] || { ext: 'bin', mime: 'application/octet-stream', label: kind };
        const name = filename
            || filenameFromDisposition(res.headers?.['content-disposition'])
            || `${fallback.label}_${id}.${fallback.ext}`;
        // El tipo del blob es el segundo cinturón: sin él, el navegador supone
        // texto plano y añade `.txt` al nombre.
        const type = res.headers?.['content-type'] || fallback.mime;

        const url = window.URL.createObjectURL(new Blob([res.data], { type }));
        const link = document.createElement('a');
        link.href = url;
        link.download = name;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        return { error: null };
    } catch (err) {
        console.error('downloadArtifact error:', err);
        return { error: err.response?.data?.error || err.message };
    }
}

export async function downloadAttachment(id, originalName) {
    try {
        const res = await api.get(`${BASE}/quote-requests/${id}/attachment`, {
            responseType: 'blob',
        });
        // Mismo criterio que en `downloadArtifact`: el nombre del adjunto suele
        // venir del pedido, pero si faltara hay que recurrir a la cabecera para
        // no guardar un archivo sin extensión.
        const name = originalName
            || filenameFromDisposition(res.headers?.['content-disposition'])
            || `print3d_attachment_${id}`;
        const type = res.headers?.['content-type'] || 'application/octet-stream';

        const url = window.URL.createObjectURL(new Blob([res.data], { type }));
        const link = document.createElement('a');
        link.href = url;
        link.download = name;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        return { error: null };
    } catch (err) {
        console.error('downloadAttachment error:', err);
        return { error: err.response?.data?.error || err.message };
    }
}
